import React, { useCallback, useEffect } from "react";

import { Field } from "redux-form";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import renderSelectField from "../../../../shared/components/form/Select";
import { connect } from "react-redux";
import { getAllActivityUsers } from "../../actions/getActivityUsers.actions";

const UserNameDropdown = ({
  label,
  disabled,
  onChange,
  id,
  required,
  dispatch,
  allUsers,
}) => {
  const maxNum = 900000000;
  const handleGetActivityUsers = useCallback(() => {
    dispatch(getAllActivityUsers({ pageNum: 1, pageSize: maxNum }));
  }, [dispatch]);

  useEffect(() => {
    handleGetActivityUsers();
  }, [handleGetActivityUsers]);

  const createUserName = (data) => {
    const newArr = data.map((d) => {
      return { ...d, username: `${d.firstName} ${d.lastName}` };
    });
    return newArr;
  };

  return (
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="issuerNumber"
          customChange={onChange}
          component={renderSelectField}
          options={
            (allUsers.response && createUserName(allUsers.response.content)) ||
            []
          }
          valueKey="email"
          disabled={disabled}
          labelKey="username"
          placeholder="All"
        />
      </div>
      {allUsers && allUsers.error ? (
        <Alert color="danger">
          Could not fetch Users
          {allUsers.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              className="float-right pointer"
              size={20}
              onClick={handleGetActivityUsers}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect((state) => ({
  allUsers: state.getActivityUsers,
}))(UserNameDropdown);
